import * as React from "react";
import { forwardRef } from "react";
const SvgSquare = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M30 29.545h40.909v40.909H30z" />
  </svg>
);
const ForwardRef = forwardRef(SvgSquare);
export default ForwardRef;
